import React, { useCallback } from 'react';
import { Column } from '@ant-design/plots';
import moment from 'moment';
import type { GetChargingPileHistoryDataOutput as GetChartApiOutputType } from '@/types/api/chargingPile/getChargingPileHistoryData';

const Chart: React.FC<{
  chartDateType: 'day' | 'week' | 'month' | 'year' | 'total';
  responseData: GetChartApiOutputType;
  chartValueType: string;
}> = ({ responseData, chartValueType, chartDateType }) => {
  const formatter = useCallback(
    (text: string) => {
      let formatText: string;
      switch (chartDateType) {
        default:
          formatText = 'M/D';
          break;
        case 'day':
          formatText = 'H時';
          break;
        case 'week':
          formatText = 'ddd';
          break;
        case 'month':
          formatText = 'D';
          break;
        case 'year':
          formatText = 'MMMM';
          break;
        case 'total':
          formatText = 'YYYY';
          break;
      }

      return moment(Number(text)).format(formatText);
    },
    [chartDateType]
  );

  const meter = chartValueType === 'expense' ? '元' : '度';

  return (
    <Column
      {...{
        animation: false,
        data: responseData?.data || [],
        xField: 'createdTime',
        xAxis: {
          label: {
            formatter,
          },
        },
        yField: chartValueType,
        yAxis: {
          label: {
            formatter: (text: string) => `${text}${meter}`,
          },
        },
        color: (data) => {
          const type = data.rateType;
          switch (type) {
            default:
              return '#69f0ae';
            case '夏季尖峰':
              return '#ff5252';
            case '夏季離峰':
              return '#ffab40';
            case '非夏季尖峰':
              return '#69f0ae';
            case '非夏季離峰':
              return '#29b6f6';
          }
        },
        isStack: true,
        seriesField: 'rateType',
        tooltip: {
          title: (text) => {
            let formatText: string;
            switch (chartDateType) {
              default:
                formatText = 'M/D';
                break;
              case 'day':
                formatText = 'M月D日H時';
                break;
              case 'week':
                formatText = 'M月D日 ddd';
                break;
              case 'month':
                formatText = 'M月D日';
                break;
              case 'year':
                formatText = 'YYYY年MMMM';
                break;
              case 'total':
                formatText = 'YYYY年';
                break;
            }
            return moment(Number(text)).format(formatText);
          },
          formatter: (data) => {
            return {
              name: data.rateType,
              value:
                chartValueType === 'expense'
                  ? `${data.expense.toFixed(2)}元`
                  : `${data.energy.toFixed(2)}度`,
            };
          },
        },
        legend: {
          position: 'top',
          itemName: {
            style: {
              fontSize: 16,
            },
          },
        },
      }}
    />
  );
};

export default React.memo(Chart);
